import { FC } from 'react';
import { Color, ColorVariant } from '@shinetools/suntheme';

import SunshineIcon, {
  IconName as SunshineIconName,
} from 'components/_core/SunshineIcon';

export interface ListIconProps {
  color?: `${Color}.${ColorVariant}`;
  name: SunshineIconName;
  flexShrink?: number;
}

const ListIcon: FC<ListIconProps> = ({ color, name, ...props }) => (
  <SunshineIcon
    flexShrink={0}
    marginRight="space-8"
    name={name}
    size="icon-16"
    {...props}
  />
);

export default ListIcon;
